/**
 * Created by neo on 16.10.21.
 */
import { makeAutoObservable } from 'mobx';
import {
  HealthDataPointAnalyticsResultEntry,
  createHealthDataPointAnalyticsResultEntry,
} from './HealthDataPointAnalyticsResultEntry';
import { HealthDataPointObjectType } from './HealthDataPointObjectType';

export type HealthDataPointAnalyticsResultJson = {
  id: string;
  dataPoints: HealthDataPointAnalyticsResultEntry[];
};

export type HealthDataPointAnalyticsResult = {
  id: string;
  dataPoints: HealthDataPointAnalyticsResultEntry[];
  readonly total: Record<HealthDataPointObjectType, number>;
  readonly totalCount: number;
};

export function createHealthDataPointAnalyticsResult(
  json?: Partial<HealthDataPointAnalyticsResultJson>,
): HealthDataPointAnalyticsResult {
  return makeAutoObservable({
    id: json?.id ?? '',
    dataPoints: (json?.dataPoints ?? []).map((a) => createHealthDataPointAnalyticsResultEntry(a)),

    get total(): Record<HealthDataPointObjectType, number> {
      return this.dataPoints.reduce(
        (agg, curr) => Object.assign(agg, { [curr.type]: curr.value }),
        {} as Record<string, number>,
      );
    },

    get totalCount(): number {
      return this.dataPoints.reduce((total, curr) => total + curr.count, 0);
    },
  });
}
